import * as Ariakit from '@ariakit/react';
import cn from 'classnames';
import { useSelect } from '#components/patterns/forms/select/SelectContext.tsx';
import styles from './SelectItem.module.css';

type Props = {
  children: React.ReactNode;
  /** Item is a static message, not selectable */
  isMessage?: boolean;
  className?: string;
  /** If this is being used in a searchable select, set this to true */
  searchable?: boolean;
} & Ariakit.SelectItemProps;

export function SelectItem({ children, isMessage, className, searchable, ...props }: Props) {
  const { store: select } = useSelect();
  const value = Ariakit.useStoreState(select, 'value');
  const isSelected = value === props.value;

  return (
    <Ariakit.SelectItem
      className={cn(styles.SelectItem, {
        [styles.SelectItem___isSelected]: isSelected,
        [styles.SelectItem___isMessage]: isMessage,
      })}
      disabled={isMessage}
      render={searchable ? <Ariakit.ComboboxItem /> : undefined}
      {...props}
    >
      <span
        className={cn(styles.SelectItem_content, { [styles.SelectItem_content___isMessage]: isMessage }, className)}
      >
        {children}
      </span>
    </Ariakit.SelectItem>
  );
}
